// extracted by mini-css-extract-plugin
export default {"default":"ImagesAvatar_default"};